'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('./styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_Component) {
    _inherits(Tooltip, _Component);

    function Tooltip(props) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

        _this.state = {
            triPosition: 0,
            shift: 0
        };
        _this.displayMessage = _this.displayMessage.bind(_this);
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var coordinates = this.props.coordinates;


            var d1 = coordinates.divWidth;
            var d2 = document.getElementById('toolTip').getBoundingClientRect().width;
            this.setState({
                triPosition: (d2 - 11.31) / 2,
                shift: (d1 - d2) / 2
            });
        }
    }, {
        key: 'displayMessage',
        value: function displayMessage(message) {
            var _this2 = this;

            if (this.props.listView) {
                return _react2.default.createElement(
                    'div',
                    {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: 3,
                            background: this.props.backgroundColor,
                            padding: 5
                        },
                        id: 'toolTip'
                    },
                    this.props.message.map(function (msg) {
                        return _react2.default.createElement(
                            'div',
                            {
                                key: msg,
                                style: _extends({}, _colors.text, {
                                    background: _this2.props.backgroundColor,
                                    color: 'white',
                                    fontSize: 14,
                                    borderRadius: 3,
                                    fontFamily: 'Source Sans Pro',
                                    padding: '7px 12px 7px 12px',
                                    whiteSpace: 'nowrap'
                                })
                            },
                            msg
                        );
                    })
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    {
                        id: 'toolTip',
                        style: {
                            background: this.props.backgroundColor,
                            borderRadius: 3,
                            color: 'white',
                            fontSize: 12,
                            fontFamily: 'Source Sans Pro',
                            padding: '7px 12px 7px 12px',
                            textAlign: 'center',
                            whiteSpace: 'nowrap'
                        }
                    },
                    this.props.message
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                message = _props.message,
                coordinates = _props.coordinates,
                backgroundColor = _props.backgroundColor,
                stylePosition = _props.stylePosition,
                position = _props.position,
                listView = _props.listView;

            var pos = void 0;
            var reactGrid = document.getElementsByClassName('react-grid-Grid')[0];
            if (position !== null) {
                pos = position;
            } else {
                if (reactGrid && reactGrid.clientHeight - coordinates.y <= 35) {
                    pos = 'top';
                } else {
                    pos = 'bottom';
                }
            }

            var res = void 0;
            if (pos === 'top' && this.props.listView !== true) {
                res = _react2.default.createElement(
                    'div',
                    {
                        style: {
                            position: stylePosition,
                            top: coordinates.y - 34 - 16,
                            left: coordinates.x + this.state.shift,
                            zIndex: 20
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            id: 'toolTip',
                            style: {
                                background: backgroundColor,
                                borderRadius: 3,
                                color: 'white',
                                fontSize: 12,
                                fontFamily: 'Source Sans Pro',
                                padding: '0px 12px 7px 12px',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            }
                        },
                        _react2.default.createElement('div', {
                            style: {
                                height: 8,
                                width: 8,
                                backgroundColor: backgroundColor,
                                transform: 'rotate(45deg)',
                                position: 'relative',
                                left: this.state.triPosition,
                                top: 23
                            }
                        }),
                        message
                    )
                );
            } else if (reactGrid) {
                res = _react2.default.createElement(
                    'div',
                    {
                        style: {
                            position: stylePosition,
                            top: coordinates.y,
                            left: coordinates.x + this.state.shift,
                            zIndex: 20
                        }
                    },
                    _react2.default.createElement('div', {
                        style: {
                            height: 8,
                            width: 8,
                            backgroundColor: backgroundColor,
                            transform: 'rotate(45deg)',
                            position: 'relative',
                            left: this.state.triPosition,
                            top: 5.655
                        }
                    }),
                    this.displayMessage()
                );
            } else {
                res = _react2.default.createElement('div', null);
            }
            return res;
        }
    }]);

    return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
    coordinates: _propTypes2.default.object.isRequired,
    stylePosition: _propTypes2.default.string,
    backgroundColor: _propTypes2.default.string,
    position: _propTypes2.default.string
};

Tooltip.defaultProps = {
    coordinates: {
        x: 0,
        y: 0,
        divWidth: 0
    },
    stylePosition: 'absolute',
    backgroundColor: _colors.graphite,
    position: null
};

exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map